var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":'chart-'+ _vm.idx},on:{"click":function($event){return _vm.handle()}}}),(_vm.tooltipTag)?_c('div',[_c('WordCard',{attrs:{"word":_vm.word,"tooltipTag":_vm.tooltipTag},on:{"closeTooltipTag":function($event){return _vm.closeDisplayTag()}}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }